import { Instagram, MapPin } from "lucide-react";
import { SOCIALS } from "../data/services";

export default function Footer() {
  return (
    <footer
      className="border-t border-[#27272a] bg-[#0a0a0a] pt-20 pb-10"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[0.95]">
              LET'S BUILD YOUR
              <br />
              <span className="text-gold">BREAKING EMPIRE.</span>
            </h2>
            <p className="text-zinc-400 mt-6 max-w-md leading-relaxed">
              Studio hire, streamer tech, custom branding, card prep, grading and
              consignment — one roof in Eastbourne.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">
              The Brands
            </p>
            <ul className="space-y-3 text-zinc-300">
              <li>
                <a
                  href={`https://instagram.com/${SOCIALS.studios.replace("@", "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline inline-flex items-center gap-2 hover:text-white"
                  data-testid="footer-social-studios"
                >
                  <Instagram size={16} /> {SOCIALS.studios}
                </a>
              </li>
              <li>
                <a
                  href={`https://instagram.com/${SOCIALS.collectibles.replace("@", "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="link-underline inline-flex items-center gap-2 hover:text-white"
                  data-testid="footer-social-collectibles"
                >
                  <Instagram size={16} /> {SOCIALS.collectibles}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">
              Studio
            </p>
            <p className="inline-flex items-start gap-2 text-zinc-300">
              <MapPin size={16} className="mt-1 shrink-0" />
              {SOCIALS.location}
            </p>
            <p className="text-zinc-500 text-sm mt-3">
              Advance booking required. Inquire for recurring slot discounts.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#27272a] flex flex-col sm:flex-row justify-between gap-3 text-zinc-500 text-xs font-mono uppercase tracking-[0.15em]">
          <span>© {new Date().getFullYear()} South East Collectibles</span>
          <span>Eastbourne · England · Broadcast-Grade</span>
        </div>
      </div>
    </footer>
  );
}
